module.exports = __webpack_public_path__ + "images/newerp_button3.1782880901430.png";